<template>
  <div class="card">
    <div class="card-wrap van-hairline--bottom">
      <div class="main">
        <div class="content">
          <h2 class="title line-clamp-2">{{ card.name }}</h2>
          <p class="description line-clamp-2">{{ card.description }}</p>
        </div>
        <img-lazy v-if="card.thumbnail" class="thumbnail" :src="card.thumbnail | thumbnail(160, 160)"/>
      </div>
      <!--<div class="foot">-->
        <!--<div class="data">-->
          <!--<span class="item"><i class="iconfont icon-xin"></i>{{ news.like }}</span>-->
          <!--<span class="item"><i class="iconfont icon-pinglun"></i>{{ news.comment }}</span>-->
          <!--<span class="item"><i class="iconfont icon-shoucang_xuanzhongzhuangtai"></i>{{ news.view }}</span>-->
        <!--</div>-->
        <!--<div class="time"><i class="iconfont icon-shijian"></i>{{ news.createTime | formatTime }}</div>-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
  import ImgLazy from '@/components/ImgLazy'

  export default {
    name: "card-school",
    components: {ImgLazy},
    props: {
      card: {
        type: Object,
        required: true,
        default: () => {return {}}
      }
    },
  }
</script>

<style lang="less" scoped>
  .card {
    padding: 0 10px;
  }

  .card-wrap {
    padding: 15px 0;
  }

  .main {
    display: flex;
    height: 80px;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title {
    font-size: 15px;
    line-height: 24px;
    color: #191919;
    max-height: 48px;
  }

  .description {
    font-size: 12px;
    line-height: 16px;
    color: #bcbfc0;
    max-height: 32px;
    margin-bottom: 5px;
    overflow: hidden;
  }

  .thumbnail {
    width: 80px;
    height: 80px;
    margin-left: 10px;
  }

  /*.foot {*/
    /*display: flex;*/
    /*justify-content: space-between;*/
    /*color: #9da0a3;*/
  /*}*/

  /*.data {*/
    /*.item {*/
      /*margin-right: 24px;*/
    /*}*/
    /*.iconfont {*/
      /*margin-right: 3px*/
    /*}*/
  /*}*/
</style>